import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Sparkles, LogOut, Image } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from '../LanguageSwitcher';

const ArchitectureHeader: React.FC = () => {
    const { profile, signOut } = useAuth();
    const credits = profile?.credits ?? 0;

    return (
        <header className="h-12 w-full bg-stone-950 border-b border-stone-800 flex items-center justify-between px-3 md:px-6 z-20 shrink-0 select-none overflow-x-auto hide-scrollbar">
            <div className="flex items-center gap-2 md:gap-3 shrink-0">
                <div className="flex items-center gap-1.5 md:gap-2">
                    <div className="w-2 h-2 rounded-full bg-orange-500 shadow-[0_0_8px_rgba(249,115,22,0.6)]"></div>
                    <span className="text-zinc-100 font-bold tracking-[0.2em] uppercase text-xs">Dotting</span>
                </div>
                <div className="h-4 w-px bg-stone-800"></div>
                <span className="text-orange-500/80 text-[8px] md:text-[10px] font-mono tracking-wide">ARCHITECTURE</span>
            </div>

            <div className="flex items-center gap-2 md:gap-6 shrink-0 pl-2">
                {/* Gallery Link */}
                <Link
                    to="/app/architecture/gallery"
                    className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-zinc-400 hover:text-white hover:bg-stone-900 transition-all border border-transparent hover:border-stone-800"
                    title="View Gallery"
                >
                    <Image size={16} />
                    <span className="text-xs font-medium hidden sm:inline">Gallery</span>
                </Link>

                <div className="h-4 w-px bg-stone-800 hidden md:block mx-1"></div>

                {/* Credits Counter */}
                <div className="flex items-center gap-1.5 md:gap-2 bg-stone-900 rounded-full px-2 py-1 md:px-3 md:py-1 border border-stone-800 group hover:border-stone-700 transition-colors">
                    <Sparkles className="w-3 h-3 text-orange-400 group-hover:text-orange-300 transition-colors shrink-0" />
                    <span className="text-zinc-300 text-xs font-medium tabular-nums whitespace-nowrap">{credits} <span className="text-zinc-600 ml-1 hidden sm:inline">Credits</span></span>
                </div>

                {/* Language Switcher Button */}
                <LanguageSwitcher />

                <div className="h-4 w-px bg-stone-800 hidden md:block mx-1"></div>

                {/* Logout Button */}
                <button
                    onClick={signOut}
                    className="p-1.5 rounded-md text-zinc-500 hover:text-red-400 hover:bg-red-950/30 transition-colors"
                    title="Sign Out"
                >
                    <LogOut size={14} />
                </button>
            </div>
        </header>
    );
};

export default ArchitectureHeader;
